import type { ErrorTranslations } from "./utils";

export default {
  not_found: {
    EN: "Department not found",
    RO: "Departamentul nu a fost găsit",
  },
  root_already_exists: {
    EN: "Root department already exists",
    RO: "Există deja un departament principal",
  },
  user_already_assigned: {
    EN: "User already assigned to a department",
    RO: "Utilizatorul este deja asignat unui departament",
  },
} satisfies ErrorTranslations;
